export default {
  FETCHED_SINGLE: 'FETCHED_LEADERBOARD',
};
